interface ProgressBarProps {
  value: number;
  tone?: 'primary' | 'accent' | 'secondary';
  className?: string;
}

const toneClasses: Record<string, string> = {
  primary: 'bg-primary-500',
  accent: 'bg-accent-500',
  secondary: 'bg-secondary-500',
};

export default function ProgressBar({ value, tone = 'primary', className = '' }: ProgressBarProps) {
  const clamped = Math.max(0, Math.min(100, value));
  return (
    <div className={`h-2 w-full overflow-hidden rounded-full bg-background-200 ${className}`}>
      <div
        className={`h-full rounded-full transition-all ${toneClasses[tone]}`}
        style={{ width: `${clamped}%` }}
      />
    </div>
  );
}